import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    apiUrl: 'https://biz-api.herokuapp.com/',
    isMoreMomy: false,
    prodInfos: [],
    newprodInfos: [],
    recommendInfo: [],
    ignoreBaseLine: false,
    addBuyUrl: '',
  },
  mutations: {},
  actions: {},
})
